export enum JobPostType {
    FullTime = 'full_time',
    PartTime = 'part_time',
    Mixed = 'mixed',
}
